export default "__VITE_ASSET__Dcol5jAP__"